/**
 * Define variables so they could be easily accessible through both JavaScript and
 * Sass, availability in Sass through 'sass-vars-loader', where exported objects can
 * be accessed through map-get() sass function.
 *
 * Example usage in scss-file(s):
 *
 *  .some-style {
 *    color: map-get($colors, darkBlue1);
 *    background-color: map-get($colors, semiWhite);
 *  }
 *
 *  $some-variable: map-get($colors: lightBlue1);
 *
 */

const colors = {
  white: '#FFF',
  semiWhite: '#F8F9F8',
  darkBlue1: '#002136',
  darkBlue2: '#143145',
  lightBlue1: '#4895B6',
  lightBlue2: '#438BAA',
  lightBlue3: '#1d7398',
  green1: '#6AB556',
  green2: '#64A753',
  lightGray1: '#EAEAEA',
  lightGray2: '#D7D7D7',
  mediumGray1: '#909090',
  mediumGray2: '#8E8E8E',
  darkGray1: '#888888',
  darkGray2: '#707070',
  darkGray3: '#666',
  darkGray4: '#505050',
  yellow1: '#FFD400',
  yellow2: '#E4B60B',
  yellow3: '#FDBB00',
  red1: '#DB2A30',
  red2: '#C42128',
};

const campaignColors = {
  blackFriday: {
    id: 2,
    background: '#000',
    text: colors.white,
  },
  christmasSale: {
    id: 3,
    background: '#B70016',
    text: colors.white,
  },
  dailyDeals: {
    id: 4,
    background: '#9B051A',
    text: colors.white,
  },
  cyberMonday: {
    id: 6,
    background: '#5AA546',
    text: colors.white,
  },
  blackFridayWeekend: {
    id: 7,
    background: '#000',
    text: colors.white,
  },
  januarySale: {
    id: 12,
    background: '#4895B6',
    text: colors.white,
  },
};

const brandColors = {
  twitter: '#00ACED',
  facebook: '#3B5998',
  pricespy: '#4895B6',
};

const ratingStarColors = {
  inactive: colors.lightGray2,
  active: colors.yellow3,
};

const layout = {
  headerHeightDesktop: '70px',
};

module.exports = {
  colors,
  campaignColors,
  brandColors,
  ratingStarColors,
  layout,
};
